module.exports = __webpack_public_path__ + "img/doc-2.34f175f2.jpg";